/**
 * GA4 User-ID 連携。
 *
 * サインインで authInfoStore.sub が入ったら gtag に user_id をセットし、
 * サインアウトで sub が空になったらクリアする。サインインのフロー
 * (password / Google / token refresh) すべてが authInfoStore 経由なので
 * ここに集約すれば漏れなく動く。
 *
 * Cognito sub (UUID) のみを送る。email / 氏名等 PII は絶対に送らない。
 * 詳細: doc/architecture/analytics.md「User-ID 連携」
 */
export default defineNuxtPlugin(() => {
  const { gtag } = useGtag()
  const authInfoStore = useAuthInfoStore()

  watch(
    () => authInfoStore.sub,
    (sub) => {
      gtag('set', { user_id: sub || null })
    },
    { immediate: true },
  )
})
